export const locales = {
    "no": {
        "header": "Rediger miljøer",
        "add": "Nytt",
        "form-close": "Lukk",
        "form-id": "Id",
        "form-name": "Navn",
        "form-description": "Beskrivelse",
        "form-scheduledStartup": "Skedulert oppstart (cron-uttrykk)",
        "form-scheduledUptime": "Skedulert kjøretid (timer)",
        "form-save": "Lagre",
        "list-header-name": "Navn",
        "list-header-description": "Beskrivelse",
        "list-header-edit": "Rediger"
    }
};